import { useState, useEffect, useCallback } from 'react'
import { apiClient } from '../api/client'
import type { ProfileResponse } from '../api/types'

type UseProfileResult = {
  profile: ProfileResponse | null
  loading: boolean
  syncing: boolean
  error: string | null
  syncFamily: () => Promise<boolean>
}

/**
 * プロフィールを管理するフック
 */
export function useProfile(): UseProfileResult {
  const [profile, setProfile] = useState<ProfileResponse | null>(null)
  const [loading, setLoading] = useState(true)
  const [syncing, setSyncing] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await apiClient.getProfile()
        setProfile(data)
      } catch (err) {
        console.error('Failed to fetch profile:', err)
        setError('プロフィールの読み込みに失敗しました')
      } finally {
        setLoading(false)
      }
    }

    fetchProfile()
  }, [])

  const syncFamily = useCallback(async (): Promise<boolean> => {
    setSyncing(true)
    setError(null)

    try {
      const response = await apiClient.syncFamily()
      setProfile(response.profile)
      return true
    } catch (err) {
      console.error('Failed to sync family:', err)
      setError(err instanceof Error ? err.message : '家族情報の同期に失敗しました')
      return false
    } finally {
      setSyncing(false)
    }
  }, [])

  return {
    profile,
    loading,
    syncing,
    error,
    syncFamily,
  }
}
